(function () {


const $ec22e1b7ac16ce9d$var$COOKIE_NAME = 'aw_user_is_corp_admin';
const $ec22e1b7ac16ce9d$var$COOKIE_HOURS = 3;
const $ec22e1b7ac16ce9d$var$EVENT_NAME = 'adw:corpAdminResolved';
const $ec22e1b7ac16ce9d$var$setCorpAdminCookie = (value)=>{
    const expires = new Date(Date.now() + $ec22e1b7ac16ce9d$var$COOKIE_HOURS * 3600000);
    window.Cookies?.set($ec22e1b7ac16ce9d$var$COOKIE_NAME, value, {
        expires: expires,
        path: '/',
        sameSite: 'Strict',
        secure: true
    });
};
const $ec22e1b7ac16ce9d$var$deleteCorpAdminCookie = ()=>{
    window.Cookies?.remove($ec22e1b7ac16ce9d$var$COOKIE_NAME, {
        path: '/'
    });
};
/**
 * Dispatches `adw:corpAdminResolved` on `document`.
 * detail.isCorpAdmin {boolean} — whether the current user is a corporate account admin.
 * detail.fromCache   {boolean} — true when the value came from the cookie, false after a live API call.
 *
 * Usage:
 *   document.addEventListener('adw:corpAdminResolved', ({ detail }) => {
 *     if (detail.isCorpAdmin) { ... }
 *   });
 */ const $ec22e1b7ac16ce9d$var$applyCorpAdminVisibility = (isCorpAdmin)=>{
    if (!isCorpAdmin) document.querySelectorAll('.corp-admin-link').forEach((el)=>{
        el.classList.add('d-none');
    });
};
const $ec22e1b7ac16ce9d$var$dispatchResolved = (isCorpAdmin, fromCache)=>{
    $ec22e1b7ac16ce9d$var$applyCorpAdminVisibility(isCorpAdmin);
    document.dispatchEvent(new CustomEvent($ec22e1b7ac16ce9d$var$EVENT_NAME, {
        detail: {
            isCorpAdmin: isCorpAdmin,
            fromCache: fromCache
        }
    }));
};
const $ec22e1b7ac16ce9d$var$fetchAndCacheAdminStatus = async ()=>{
    if (Object.keys(window.Zephr || {}).length === 0) return;
    // Check if the user has any active Zephr products with "corp" in the name before making the API call
    if (window.Zephr?.accessDetails?.activeProducts?.some((name)=>name.toLowerCase?.().includes('corp'))) try {
        const response = await fetch('/wp-json/adw-zephr/v1/corp-admin-status', {
            method: 'GET',
            credentials: 'same-origin'
        });
        const data = await response.json();
        $ec22e1b7ac16ce9d$var$setCorpAdminCookie(data.is_corp_admin ? 'true' : 'false');
        $ec22e1b7ac16ce9d$var$dispatchResolved(data.is_corp_admin, false);
    } catch  {
    // Silent fail — leave cookie unset so the next page load retries
    }
    else $ec22e1b7ac16ce9d$var$applyCorpAdminVisibility(false);
};
const $ec22e1b7ac16ce9d$var$getParam = (name)=>new URLSearchParams(window.location.search).get(name);
const $ec22e1b7ac16ce9d$var$removeUrlParam = (name, delayMs = 5000)=>{
    setTimeout(()=>{
        const url = new URL(window.location.href);
        url.searchParams.delete(name);
        history.replaceState(null, '', url.toString());
    }, delayMs);
};
const $ec22e1b7ac16ce9d$var$init = ()=>{
    // ?signing_in=true — user just logged in with a fresh blaize_session.
    // Force a fresh API call by clearing any stale cookie, then clean up the param.
    if ($ec22e1b7ac16ce9d$var$getParam('signing_in') === 'true') {
        $ec22e1b7ac16ce9d$var$deleteCorpAdminCookie();
        $ec22e1b7ac16ce9d$var$removeUrlParam('signing_in');
        $ec22e1b7ac16ce9d$var$fetchAndCacheAdminStatus();
        return;
    }
    const cookieVal = window.Cookies?.get($ec22e1b7ac16ce9d$var$COOKIE_NAME);
    if (cookieVal !== undefined) {
        const isCorpAdmin = cookieVal === 'true';
        $ec22e1b7ac16ce9d$var$dispatchResolved(isCorpAdmin, true);
        return;
    }
    // Cookie absent — call the REST API to determine admin status.
    // The API returns false for logged-out or non-admin users.
    $ec22e1b7ac16ce9d$var$fetchAndCacheAdminStatus();
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', $ec22e1b7ac16ce9d$var$init);
else $ec22e1b7ac16ce9d$var$init();

})();
//# sourceMappingURL=adw-corp-admin.js.map
